// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource';
import VueLazyload from 'vue-lazyload'; // 懒加载

import store from './store';

let SEC = require('common/js/utils/core.js');

Vue.use(VueResource);
Vue.use(VueLazyload, {
    preLoad: 1.5
}) // 懒加载

Vue.http.options.emulateJSON = true;
Vue.http.options.xhr = {withCredentials: true};
Vue.http.interceptors.push(function(request, next) {//拦截器
    request.credentials = true; // 跨域携带cookie

    if (request.url !== '/api/recommend/recommend?type=buy-buy') {
        // 除了获取推荐商品外，所有网络请求都需要有loading状态，所以全局设置loading图标，发送请求前进入loading状态
        store.commit('SET_LOADING_SHOW');
    }

    next(res => {
        // 请求返回后取消loading状态
        store.commit('SET_LOADING_HIDE');
        if (!res.ok) {
            // 未正常返回数据，提示网络错误
            store.dispatch('showToast', '网络错误');
        } else {
            const {retCode, retMsg} = res.data;
            if (retCode !== 0 && retMsg) {
                store.dispatch('showToast', retMsg);
            }
        }
        return res;
    });
});

Vue.config.productionTip = false;

try {
    if (!SEC.cookie.get('appsource')) {
        SEC.cookie.set({
            name: 'appsource',
            value: '60',
            domain: '.secoo.com'
        });
    }
} catch (err) {}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js